import React, { useState, useEffect, useMemo, useContext } from 'react';
import ProjectsListCard from '../ProjectsListCard/ProjectsListCard';
import CreateCloudfrontUrl from '/src/services/CreateCloudfrontUrl';
import CompanySelectionGrid from '../CompanySelectionGrid/CompanySelectionGrid';
import { v4 as uuidv4 } from 'uuid';
import { FetchThumbtackListings } from '/src/services/FetchThumbtackListings';
import { AddressSearchContext, WindowSizeContext } from '/src/App';

import './style.css';

const CreatePlanFlow = ({ 
    property_data, 
    projects, 
    onComplete,
    // userInsurance,
    // userPreferredRetailers,
    // userPreferredServiceProviders,
    // property_id,
    userPlans = [],
    createFromLab = false,
    labProjectsList = []
}) => {

    const { deviceType } = useContext(WindowSizeContext);

    // Get the portalData from the AddressSearchContext
    const { portalData } = useContext(AddressSearchContext);

    console.log(property_data);

    // Get the property_id and the zip code from the property_data
    const property_id = property_data.address_id;
    const zip_code = property_data.data.property_details.zip;
    console.log(zip_code);
    console.log(property_id);

    // Load the icons and companies from local storage
    const { icons, companies } = portalData;
    // const icons = JSON.parse(localStorage.getItem('icons'));
    // const companies = JSON.parse(localStorage.getItem('companies'));

    // Map through the companies and use the 'icon' key as a key to get the icon url and add to company object
    const companiesWithIcons = companies.map(company => ({
        ...company,
        iconUrl: icons[company.icon]
    }));

    // Filter the companies by company_type = 'Retailer'
    const retailers = companiesWithIcons.filter(company => company.company_type === 'Retailer');

    // Filter the companies by company_type = "Service"
    const serviceProviders = companiesWithIcons.filter(company => company.company_type === "Service");

    // Filter the companies by company_type = "Insurance"
    const insuranceCompanies = companiesWithIcons.filter(company => company.company_type === "Insurance");


    // Create the "Other" option
    const otherOption = {
        id: "9999",
        name: "Other",
    }

    // Add the "Other" option to the retailers, service providers, and insurance companies
    retailers.push(otherOption);
    serviceProviders.push(otherOption);
    insuranceCompanies.push(otherOption);


    // Sort the projects by project_total_payback HIGH to LOW and add diyPreference
    const sortedProjects = projects.map(project => ({
        ...project,
        diyPreference: project.project_cost_labor > 0 ? 'pro' : 'diy'
    })).sort((a, b) => b.project_total_payback - a.project_total_payback);

    // Create unique house areas from projects
    const houseAreas = useMemo(() => {
        const uniqueAreas = new Map();

        // Add ALL option first
        uniqueAreas.set('all', {
            project_home_category_id: 'all',
            project_home_category: 'All Areas',
            house_category_icon: 'Home-Black.png' // You might want to adjust this icon
        });

        // Add other areas
        projects.forEach(project => {
            const id = project.project_home_category_id;
            if (!uniqueAreas.has(id)) {
                uniqueAreas.set(id, {
                    project_home_category_id: id,
                    project_home_category: project.project_home_category,
                    house_category_icon: project.house_category_icon
                });
            }
        });

        // Convert to array and sort alphabetically by category name, keeping 'All Areas' first
        return Array.from(uniqueAreas.values()).sort((a, b) => {
            if (a.project_home_category === 'All Areas') return -1;
            if (b.project_home_category === 'All Areas') return 1;
            return a.project_home_category.localeCompare(b.project_home_category);
        });
    }, [projects]);

    // Add state for selected filter
    const [selectedFilter, setSelectedFilter] = useState('all');

    // Filter projects based on selection
    const filteredProjects = useMemo(() => {
        if (selectedFilter === 'all') {
            return projects;
        }
        return projects.filter(project =>
            project.project_home_category_id === selectedFilter
        );
    }, [projects, selectedFilter]);


    // Load the user from local storage
    const user = JSON.parse(localStorage.getItem('user')) || {};

    // Get the user's insurance provider, preferred retailers, and preferred service providers
    const userInsurance = user.insuranceProvider || null;
    const userPreferredRetailers = user.preferredRetailers || [];
    const userPreferredServiceProviders = user.preferredServiceProviders || [];


    let initialUserSelectedProjectIds;
    if (Array.isArray(projects)) {
        initialUserSelectedProjectIds = [];
    } else {
        initialUserSelectedProjectIds = projects.project_id;
    }

    let initialUserSelectedInsurance;
    let needToSaveInsurance = true;
    if (userInsurance) {
        initialUserSelectedInsurance = userInsurance;
        needToSaveInsurance = false;
    } else {
        initialUserSelectedInsurance = null;
    }

    let initialUserSelectedPreferredRetailers;
    let needToSavePreferredRetailers = true;
    if (userPreferredRetailers.length > 0) {
        initialUserSelectedPreferredRetailers = userPreferredRetailers;
        needToSavePreferredRetailers = false;
    } else {
        initialUserSelectedPreferredRetailers = [];
    }

    let initialUserSelectedPreferredServiceProviders;
    let needToSavePreferredServiceProviders = true;
    if (userPreferredServiceProviders.length > 0) {
        initialUserSelectedPreferredServiceProviders = userPreferredServiceProviders;
        needToSavePreferredServiceProviders = false;
    } else {
        initialUserSelectedPreferredServiceProviders = [];
    }


    // Move this inside the component but before any other hooks
    const userPlanNamePlaceholder = useMemo(() => {
        const currentTime = new Date().toLocaleString();
        return `My Resilience Plan #${userPlans.length + 1}`;
    }, []); // Empty dependency array means this only runs once

    console.log("LabProjectsList", labProjectsList);

    const [steps, setSteps] = useState([]);
    const [currentStep, setCurrentStep] = useState(0);
    const [userSelectedProjectIds, setUserSelectedProjectIds] = useState(initialUserSelectedProjectIds);
    const [userSelectedProjects, setUserSelectedProjects] = useState(labProjectsList);
    const [userDIYPreferences, setUserDIYPreferences] = useState(null);
    const [userSelectedInsurance, setUserSelectedInsurance] = useState(initialUserSelectedInsurance);
    const [userSelectedPreferredRetailers, setUserSelectedPreferredRetailers] = useState(initialUserSelectedPreferredRetailers);
    const [userSelectedPreferredServiceProviders, setUserSelectedPreferredServiceProviders] = useState(initialUserSelectedPreferredServiceProviders);
    const [userPlanName, setUserPlanName] = useState(userPlanNamePlaceholder);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        if (!createFromLab) {
            setUserSelectedProjects(sortedProjects.filter((project) => userSelectedProjectIds.includes(project.project_id)));
        }
    }, [userSelectedProjectIds]);

    console.log(userSelectedProjects);


    useEffect(() => {
        if (!loaded && steps.length === 0) {

            const newSteps = [];

            if (((userSelectedProjectIds.length === 0) || (userSelectedProjectIds.length > 1)) && !createFromLab) {
                newSteps.push({
                    type: 'select-projects',
                    title: "Select the projects you'd like to take on...",
                    // component: <SelectProjects />
                })
            }

            let doWorkYourselfTitle = 'Do you plan on doing this work yourself or hiring a pro?';
            if (createFromLab) {
                doWorkYourselfTitle = "A few quick questions to ensure we create the best plan for you. First, to confirm, this is who would be doing the work? Don't worry, you can change it later.";
            }

            newSteps.push({
                type: 'select-diy-preferences',
                title: doWorkYourselfTitle,
            })

            if (!userSelectedInsurance) {
                newSteps.push({
                    type: 'select-insurance',
                    title: 'Who is your current home insurance provider?',
                })
            }

            if (userSelectedPreferredRetailers.length === 0) {
                newSteps.push({
                    type: 'select-preferred-retailers',
                    title: 'Do you prefer certain home improvement retailers?',
                })
            }

            if (userSelectedPreferredServiceProviders.length === 0) {
                newSteps.push({
                    type: 'select-preferred-service-providers',
                    title: 'Do you prefer to use certain home improvement service providers?',
                })
            }

            newSteps.push({
                type: 'select-plan-name',
                title: 'Give your plan a name',
            })


            // Iterate through the steps and add a step: # to each starting at 0
            newSteps.forEach((step, index) => {
                newSteps[index] = { ...step, step: index };
            });
            setSteps(newSteps);
            setLoaded(true);
        }
    }, [])

    // Add project to userSelectedProjectIds AFTER CONFIRMING THE ID IS NOT IN THE ARRAY      
    const handleProjectSelection = (id) => {
        if (!userSelectedProjectIds.includes(id)) {
            setUserSelectedProjectIds([...userSelectedProjectIds, id]);
        }
    }

    // Remove project from userSelectedProjectIds AFTER CONFIRMING THE ID IS IN THE ARRAY
    const handleProjectDeselection = (id) => {
        if (userSelectedProjectIds.includes(id)) {
            setUserSelectedProjectIds(userSelectedProjectIds.filter((p) => p !== id));
        }
    }

    // Handle the DIY toggle by taking in the project id and the diy preference and updating userSelectedProjects
    const handleDIYToggle = (id, diyPreference) => {
        setUserSelectedProjects(userSelectedProjects.map((project) => {
            if (project.project_id === id) {
                return { ...project, diyPreference };
            }
            return project; // Return unchanged project if ID doesn't match
        }));
    }

    const diyIconFilepath = "DIY-White.png"
    const diyIconUrl = CreateCloudfrontUrl(diyIconFilepath);

    const handleInsuranceSelection = (id) => {
        if (userSelectedInsurance !== id) {
            setUserSelectedInsurance(id);
        }
    }

    // Handle the retailer selection by taking in the id and adding it to / removing it from the userSelectedPreferredRetailers array
    const handleRetailerSelection = (id) => {
        if (userSelectedPreferredRetailers.includes(id)) {
            setUserSelectedPreferredRetailers(userSelectedPreferredRetailers.filter((p) => p !== id));
        } else {
            setUserSelectedPreferredRetailers([...userSelectedPreferredRetailers, id]);
        }
    }

    // Handle the service provider selection by taking in the id and adding it to / removing it from the userSelectedPreferredServiceProviders array
    const handleServiceProviderSelection = (id) => {
        if (userSelectedPreferredServiceProviders.includes(id)) {
            setUserSelectedPreferredServiceProviders(userSelectedPreferredServiceProviders.filter((p) => p !== id));
        } else {
            setUserSelectedPreferredServiceProviders([...userSelectedPreferredServiceProviders, id]);
        }
    }

    // On complete we need to save the data in two ways, all within local storage
    const handleComplete = () => {
        // Create a unique id for the plan
        const planId = uuidv4();
        const timestamp = new Date().toISOString();
        const epochTimestamp = Date.now();

        // Create a new plan object
        const newPlan = {
            planId,
            timestamp,
            epochTimestamp,
            planName: userPlanName,
            progress: 0,
            competeOverMe: false
        }

        // Map through the userSelectedProjects and get the project_id and diyPreference
        const projectData = userSelectedProjects.map((project) => ({
            project_id: project.project_id,
            diyPreference: project.diyPreference
        }));

        // Get the list of project ids from the projectData where diyPreference is 'pro'
        const projectIds = projectData.filter((project) => project.diyPreference === 'pro').map((project) => project.project_id);
        console.log('projectIds', projectIds);

        // // Fetch the thumbtack listings for the project ids (ASYNCHRONOUSLY)
        const fetchListings = async () => {
            console.log('Fetching Thumbtack listings for project:', projectIds);
            try {
                const ttListingStatus = await FetchThumbtackListings(zip_code, projectIds);

                if (!ttListingStatus) {
                    console.log('Thumbtack listings not fetched');
                } else {
                    console.log('Thumbtack listings fetched successfully');
                }

            } catch (error) {
                console.error('Error fetching Thumbtack listings:', error);
            }
        };
        fetchListings();

        // Add the project data to the new plan object
        newPlan.projectData = projectData;

        // Get existing user data from local storage
        const userLocal = JSON.parse(localStorage.getItem('user')) || {};

        // Initialize userPlans array if it doesn't exist
        userLocal.userPlans = userLocal.userPlans || [];

        // Find the property object in userPlans
        let propertyPlans = userLocal.userPlans.find(item => item.property_id === property_id);

        if (!propertyPlans) {
            // If property doesn't exist, create new property object
            propertyPlans = {
                property_id: property_id,
                plans: []
            };
            userLocal.userPlans.push(propertyPlans);
        }

        // Add the new plan to this property's plans array
        propertyPlans.plans = propertyPlans.plans || [];
        propertyPlans.plans.push(newPlan);

        // Rest of the existing code for saving preferences
        userLocal.insuranceProvider = userLocal.insuranceProvider || null;
        if (userSelectedInsurance) {
            userLocal.insuranceProvider = userSelectedInsurance;
        }

        // Add the preferred retailers directly onto the user object
        userLocal.preferredRetailers = userLocal.preferredRetailers || [];
        if (userSelectedPreferredRetailers.length > 0) {
            userLocal.preferredRetailers = userSelectedPreferredRetailers;
        }

        // Add the preferred service providers directly onto the user object
        userLocal.preferredServiceProviders = userLocal.preferredServiceProviders || [];
        if (userSelectedPreferredServiceProviders.length > 0) {
            userLocal.preferredServiceProviders = userSelectedPreferredServiceProviders;
        }


        // Save the updated user object back to local storage
        localStorage.setItem('user', JSON.stringify(userLocal));

        // Call the onComplete function
        onComplete(newPlan);
    }


    return (
        <div className={`create-plan-flow-container ${deviceType}`}>
            {/* <h1>Create a Plan</h1> */}
            {loaded &&
                <>
                    <p className={`create-plan-flow-step-title text-align-center ${deviceType}`}>{steps[currentStep].title}</p>
                    {steps[currentStep].type === 'select-projects' && (
                        <>
                            <div className={`review-all-projects__filter-section ${deviceType}`}>
                                <span className='review-all-projects__filter-section-label'>Filter by:</span>
                                <div className="review-all-projects__filter-bar">
                                    {houseAreas.map(area => (
                                        <button
                                            key={area.project_home_category_id}
                                            className={`review-all-projects__filter-button ${selectedFilter === area.project_home_category_id ? 'active' : ''}`}
                                            onClick={() => setSelectedFilter(area.project_home_category_id)}
                                        >
                                            {area.project_home_category}
                                        </button>
                                    ))}
                                </div>
                            </div>
                            <div className={`create-plan-flow-projects-container ${deviceType}`}>
                                {filteredProjects.map((project) => {

                                    const isSelected = userSelectedProjectIds.includes(project.project_id);
                                    // console.log(isSelected);
                                    return (
                                        <ProjectsListCard
                                            key={project.id}
                                            project={project}
                                            handleProjectClick={isSelected ? handleProjectDeselection : handleProjectSelection}
                                            handleAddingProjectToSimulator={handleProjectSelection}
                                            handleRemovingProjectFromSimulator={handleProjectDeselection}
                                            isSelected={isSelected}
                                            simulatorView={true}
                                            showAllDetails={false}
                                        />
                                    )
                                })}
                            </div>
                        </>
                    )}
                    {steps[currentStep].type === 'select-diy-preferences' && (
                        <div className={`create-plan-flow-projects-container ${deviceType}`}>
                            {userSelectedProjects.map((project) => {

                                const isSelected = userSelectedProjectIds.includes(project.project_id);
                                const isDIYFriendly = project.project_diy_friendly;

                                return (
                                    <div className={`create-plan-flow-projects-diy-step-container ${deviceType}`}>
                                        {/* {isDIYFriendly && (
                                            <div className="create-plan-flow-projects-diy-step-icon-container">
                                                <img src={diyIconUrl} alt="DIY Icon" className="create-plan-flow-projects-diy-step-icon" />
                                            </div>
                                        )} */}
                                        <ProjectsListCard
                                            key={project.id}
                                            project={project}
                                            handleProjectClick={isSelected ? handleProjectDeselection : handleProjectSelection}
                                            handleAddingProjectToSimulator={handleProjectSelection}
                                            handleRemovingProjectFromSimulator={handleProjectDeselection}
                                            isSelected={isSelected}
                                            simulatorView={false}
                                            showAllDetails={false}
                                        />
                                        <div className="create-plan-flow-projects-diy-step-toggle-container">
                                            <button
                                                className={`create-plan-flow-button-diy-step-toggle ${project.diyPreference === 'diy' ? 'active' : ''}`}
                                                onClick={() => handleDIYToggle(project.project_id, 'diy')}
                                            >
                                                Do It Myself
                                            </button>
                                            <button
                                                className={`create-plan-flow-button-diy-step-toggle ${(project.diyPreference === 'pro' || !project.diyPreference) ? 'active' : ''}`}
                                                onClick={() => handleDIYToggle(project.project_id, 'pro')}
                                            >
                                                Hire a Pro
                                            </button>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    )}
                    {steps[currentStep].type === 'select-insurance' && (
                        <CompanySelectionGrid companies={insuranceCompanies} userCurrentSelection={userSelectedInsurance} handleSelection={handleInsuranceSelection} />
                        // <div className="create-plan-flow-insurance-providers-grid">
                        //     {insuranceCompanies.map((company) => {

                        //         return (
                        //             <div className={`create-plan-flow-insurance-providers-grid-item ${userSelectedInsurance === company.id ? 'active' : ''}`} onClick={() => handleInsuranceSelection(company.id)}>
                        //                 {company.id === "9999" ? (
                        //                     <p>Other</p>
                        //                 ) : (
                        //                     <img src={CreateCloudfrontUrl(company.iconUrl)} alt={company.company_name} />
                        //                 )}
                        //             </div>
                        //         )
                        //     })}
                        // </div>
                    )}
                    {steps[currentStep].type === 'select-preferred-retailers' && (
                        <div className={`create-plan-flow-insurance-providers-grid ${deviceType}`}>
                            {retailers.map((company) => {

                                return (
                                    <div className={`create-plan-flow-insurance-providers-grid-item ${userSelectedPreferredRetailers.includes(company.id) ? 'active' : ''}`} onClick={() => handleRetailerSelection(company.id)}>
                                        {company.id === "9999" ? (
                                            <p>Other</p>
                                        ) : (
                                            <img src={CreateCloudfrontUrl(company.iconUrl)} alt={company.company_name} />
                                        )}
                                    </div>
                                )
                            })}
                        </div>
                    )}
                    {steps[currentStep].type === 'select-preferred-service-providers' && (
                        <div className={`create-plan-flow-insurance-providers-grid ${deviceType}`}>
                            {serviceProviders.map((company) => {

                                return (
                                    <div className={`create-plan-flow-insurance-providers-grid-item ${userSelectedPreferredServiceProviders.includes(company.id) ? 'active' : ''}`} onClick={() => handleServiceProviderSelection(company.id)}>
                                        {company.id === "9999" ? (
                                            <p>Other</p>
                                        ) : (
                                            <img src={CreateCloudfrontUrl(company.iconUrl)} alt={company.company_name} />
                                        )}
                                    </div>
                                )
                            })}
                        </div>
                    )}
                    {steps[currentStep].type === 'select-plan-name' && (
                        <div className={`create-plan-flow-plan-name-container ${deviceType} ${userPlanName === userPlanNamePlaceholder ? 'placeholder' : ''}`}>
                            <input
                                type="text"
                                value={userPlanName === userPlanNamePlaceholder ? '' : userPlanName}
                                onChange={(e) => setUserPlanName(e.target.value)}
                                onFocus={() => {
                                    if (userPlanName === userPlanNamePlaceholder) {
                                        setUserPlanName('');
                                    }
                                }}
                                onBlur={() => {
                                    if (!userPlanName.trim()) {
                                        setUserPlanName(userPlanNamePlaceholder);
                                    }
                                }}
                                placeholder={userPlanNamePlaceholder}
                            />
                        </div>
                    )}

                    <div className={`create-plan-flow-buttons-container ${deviceType}`}>
                        {steps[currentStep].step > 0 && (
                            <button className="create-plan-flow-button back" onClick={() => setCurrentStep(currentStep - 1)}>Back</button>
                        )}
                        {currentStep < steps.length - 1 && (
                            <button className="create-plan-flow-button next" onClick={() => setCurrentStep(currentStep + 1)}>Next</button>
                        )}
                        {currentStep === steps.length - 1 && (
                            <button className="create-plan-flow-button complete" onClick={() => handleComplete()}>Create My Plan</button>
                        )}
                    </div>
                </>

            }
        </div>
    );
};

export default CreatePlanFlow;
